<template>
    <PageContainer>
        <PageHeader>
            {{ $t('issueLog.show.page_title') }} - <b>{{ $t('issueLog.type.'+log.issue_type) }}</b>
        </PageHeader>

        <div class="row">
            <div class="col-12">
                <CustomerPreview :customer="getCustomer"/>

                <div class="row py-3">
                    <div class="col-md-3 mb-3 mb-md-0">
                        <preview-item :title="$t('user.name')" :description="log.user.name" />
                    </div>
                    <div class="col-md-3 mb-3 mb-md-0">
                        <preview-item :title="$t('user.email')" :description="log.user.email" />
                    </div>
                    <div class="col-md-3 mb-3 mb-md-0">
                        <preview-item :title="$t('user.role')" :description="log.user.role" />
                    </div>
                    <div class="col-md-3 mb-3 mb-md-0">
                        <preview-item :title="$t('issueLog.created_at')" :description="log.created_at" />
                    </div>
                </div>

                <div class="row">
                    <div class="col-12 fs-5">{{ $t('issueLog.products') }}</div>
                    <hr>
                </div>

                <div class="row" v-for="product in log.items">
                    <div class="col-6">
                        <preview-item :title="$t('product.name')" :description="`${product.product.name} (${product.size.size})`" />
                    </div>
                    <div class="col-6 text-end">
                        <preview-item :title="$t('product.quantity')" :description="product.quantity.toString()" />
                    </div>
                </div>
            </div>
        </div>

        <div>
            <BackButton :href="`/issueLogs/${log.issue_type}`" />
        </div>
    </PageContainer>
</template>

<script setup lang="ts">
import type {CustomerInterface, IssuedLogInterface} from "@/components/helpers/Interfaces.ts";
import PageHeader from "@/components/elements/PageHeader.vue";
import PageContainer from "@/components/elements/PageContainer.vue";
import PreviewItem from "@/components/elements/PreviewItem.vue";
import BackButton from "@/components/buttons/BackButton.vue";
import CustomerPreview from "@/components/elements/CustomerPreview.vue";
import {computed} from "vue";

const { log } = defineProps<{
    log: IssuedLogInterface
}>()

const getCustomer = computed(() => {
    return {
        name: log.customer_name,
        lastname: log.customer_lastname,
        permissionId: log.permission_id,
        document: log.customer_document
    } as CustomerInterface
})
</script>

<style scoped>

</style>
